<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->

      <el-row :gutter="20" type="flex">
        <el-col>
          <div class="flex align-center  header-search-box">
            <el-form :inline="true" >
              <el-form-item label="日期：">
                 <el-date-picker
              style="width:280px"
                v-model="dateRange"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              </el-form-item>
              <el-form-item label="分类名称：">
                 <input
                type="text"
                v-model="queryInfo.condition.categoryName"
                placeholder="请输入分类名称"
                class="input-native"
              />
              </el-form-item>
              <el-form-item label="商品名称：">
                  <input
                type="text"
                v-model="queryInfo.condition.productName"
                placeholder="请输入商品名称"
                class="input-native"
              />
              </el-form-item>
              <el-form-item label="桌台号：">
                 <input
                type="text"
                v-model="queryInfo.condition.tableName"
                placeholder="请输入桌台号"
                class="input-native"
              />
              </el-form-item>
              <el-form-item label="订单号：">
                <input
                type="text"
                v-model="queryInfo.condition.orderNumber"
                placeholder="请输入订单号"
                class="input-native"
              />
              </el-form-item>
                <el-button
              style="background-color: #f59a23; color: #fff"
              @click="search()"
              >搜索</el-button
            >
            <el-button @click="exportXls">导出</el-button>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="40"> </el-table-column>
              <!-- <el-table-column label="" align="center" prop="">
                <template slot-scope="scope">
                  <span>{{ scope.row.id }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="商家编码" align="center" prop="商家编码">
                <template slot-scope="scope">
                  <span>{{ scope.row.merchantCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商家名称" align="center" prop="商家名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.merchantName }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="分类名称" align="center" prop="分类名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.categoryName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="商品编码" align="center" prop="商品编码">
                <template slot-scope="scope">
                  <span>{{ scope.row.productCode }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="商品名称" align="center" prop="商品名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.productName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单数量" align="center" prop="订单数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.num }}</span>
                </template>
              </el-table-column>
              <el-table-column label="剩余库存" align="center" prop="剩余库存">
                <template slot-scope="scope">
                  <span>{{ scope.row.reaminingStock }}</span>
                </template>
              </el-table-column>
              <el-table-column label="类型" align="center" prop="类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == '1'">出库</span>
                  <span v-if="scope.row.type == '2'">退库</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单编号" align="center" prop="订单编号">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNumber }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="流水号" align="center"  prop="流水号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.transNo }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="桌台编码" align="center" prop="桌台编码">
                <template slot-scope="scope">
                  <span>{{ scope.row.tableCode }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="桌台号" align="center" prop="桌台号">
                <template slot-scope="scope">
                  <span>{{ scope.row.tableName }}</span>
                </template>
              </el-table-column>

            </el-table>
          </el-row></el-scrollbar
        >
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      selected: [], //当前记录选择项
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: [],
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          productName:'',
          categoryName:'',
          tableName:'',
          orderNumber:''
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.queryInfo.condition.startDt = moment()

      .format("YYYY-MM-DD");
    this.queryInfo.condition.endDt = moment()

      .format("YYYY-MM-DD");
    this.getListData();
    this.dateRange[0] = moment().format("YYYY-MM-DD");
    this.dateRange[1] = moment()

      .format("YYYY-MM-DD");
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    exportXls(){  //导出
      if (this.dateRange != null && this.dateRange.length > 0) {
        this.queryInfo.condition.startDt = this.dateRange[0];
        this.queryInfo.condition.endDt = this.dateRange[1];
      } else {
        this.queryInfo.condition.startDt = null;
        this.queryInfo.condition.endDt = null;
      }
      let data={}
      data.merchantCode=localStorage.getItem('merchantCode')
      data.startTime=this.queryInfo.condition.startDt
      data.endTime=this.queryInfo.condition.endDt
      data.orderNumber=this.queryInfo.condition.orderNumber
      data.productName=this.queryInfo.condition.productName
      data.categoryName=this.queryInfo.condition.categoryName
      data.tableName=this.queryInfo.condition.tableName
    this.$http.post('merchantProductStocks/exportExcel',data).then(res=>{
      console.log(res)
      var link=document.createElement('a')
      link.href=res.data.data
      // link.target="_blank"
      link.download='导出文件'
      // link.click()
      window.open(res.data.data)
    })
    },
    //条件查询
    search() {
      if (this.dateRange != null && this.dateRange.length > 0) {
        this.queryInfo.condition.startDt = this.dateRange[0];
        this.queryInfo.condition.endDt = this.dateRange[1];
      } else {
        this.queryInfo.condition.startDt = null;
        this.queryInfo.condition.endDt = null;
      }
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantProductStock/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantProductStocks/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantProductStocks/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
      // console.log(
      //   "that.queryInfo.condition.productName" +
      //     that.queryInfo.condition.productName
      // );
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 处理选中项
    handleSelectionChange(val) {
      console.log(val);
      this.selected = val;
      const extractedArr = val.map(item => item.id);
      this.selected = extractedArr;
    },
    async groupDel() {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post(
            "/merchantProductStocks/deleteMerchantProductStockBatch",
            this.selected
          )
          .then(function(res) {
            if (res.data.code == 200) {
              that.$notify.success({
                title: "提示",
                message: "删除成功",
                showClose: true
              });
            } else {
              that.$notify.error({
                title: "提示",
                message: "删除失败",
                showClose: true
              });
            }
            that.getListData();
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

/deep/ .el-col-24 {
  width: auto;
}

.input-native {
  line-height: 1;
  background-color: #fff;
  border-radius: 4px;
  width: 134px;
  height: 26px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  padding-left: 10px;
  padding-right: 0;
  outline: none;
  margin-right: 12px;
}
// .button-native {
//   font-size: 12px;
//   display: inline-block;
//   color: #fff;
//   white-space: nowrap;
//   text-align: center;
//   border: none;
//   border-radius: 2px;
//   cursor: pointer;
//   line-height: 22px;
//   padding: 0 5px;
// }
.update-button {
  background-color: #1e9fff;
  margin-right: 4px;
}
.delete-button {
  background-color: #ff5722;
  margin-left: 4px;
}

/deep/ .header-search-box {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 8px;
    display: flex;
    align-items: center;
    span {
      color: #606266;
      font-size: 14px;
      display: block;
      width: 66px;
    }
    input {
      border-radius: 2px;
    }
  }
  // .el-date-editor {
  //   margin-right: 12px;
  //   height: 40px !important;
  //   line-height: 40 !important;
  //   .el-range-separator {
  //     line-height: 32px;
  //   }
  // }
  > div,
  > input,
  > button {
    margin-bottom: 18px;
  }
}
</style>
